import { Directive, input, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[appTabHost]',
})
export class TabHostDirective {
  tabKey = input<string>('', { alias: 'appTabHost' });
  vcr = inject(ViewContainerRef);
}